import { OnboardingTask, OnboardingTaskName } from "types/onboarding";

export enum EligibilityCriteria {
  positiveEarnings = "positive_earnings?",
  nonNeoBank = "non_neo_bank?",
  confirmedEmail = "confirmed_email?",
}

export enum EligibilityStatus {
  notStarted = "not_started",
  pending = "pending",
  eligible = "eligible",
  completed = "completed",
  ineligible = "ineligible",
  requiresAction = "requires_action",
  rejected = "rejected",
}

export interface CardApplicationStatus {
  tasks: OnboardingTask[];
  currentTaskName: OnboardingTaskName;
  cardApplicationComplete: boolean;
  skippable: boolean;
  ineligible: boolean;
  eligibilityResult: {
    eligible: boolean;
    applicationStatus: EligibilityStatus;
    version: number;
    userActionableCriteria: EligibilityCriteria[];
  };
}
